// extracted by mini-css-extract-plugin
export var component = "components-icons-__LoadingIcon-module___component";
export var loaderIcon = "components-icons-__LoadingIcon-module___loaderIcon";
export var page = "components-icons-__LoadingIcon-module___page";
export var spin = "components-icons-__LoadingIcon-module___spin";
export var spinner = "components-icons-__LoadingIcon-module___spinner";